import type {GetListResponse, ParamsOptions} from "@/src/modules/core/types";

import type {createAmenityAccessLogApi} from "../api/create-amenity-access-log-api";
import type {AmenityAccessLog} from "../types";

type AmenityAccessLogApi = ReturnType<typeof createAmenityAccessLogApi>;

export function createAmenityAccessLogService(api: AmenityAccessLogApi) {
  return {
    async getAccessLogs(options: ParamsOptions): Promise<GetListResponse<AmenityAccessLog>> {
      const {data} = await api.search(options);
      const raw = data as {
        data?: AmenityAccessLog[] | {data?: AmenityAccessLog[]};
        amenity_access_logs?: AmenityAccessLog[];
        meta?: {total: number; from?: number; to?: number};
      };
      const items: AmenityAccessLog[] = Array.isArray(raw.data)
        ? raw.data
        : Array.isArray(raw.amenity_access_logs)
          ? raw.amenity_access_logs
          : (raw.data as {data?: AmenityAccessLog[]})?.data ?? [];
      const meta = raw.meta ?? {total: 0};
      return {
        data: items,
        meta: {
          total: meta.total,
          from: meta.from ?? 0,
          to: meta.to ?? 0,
        },
      };
    },

    async getAccessLog(id: number): Promise<AmenityAccessLog | undefined> {
      const {data} = await api.getById(id);
      return data.data;
    },

    async createAccessLog(payload: Record<string, unknown>): Promise<AmenityAccessLog | undefined> {
      const {data} = await api.create(payload);
      return data.data;
    },

    async updateAccessLog(
      id: number,
      payload: Record<string, unknown>,
    ): Promise<AmenityAccessLog | undefined> {
      const {data} = await api.update(id, payload);
      return data.data;
    },

    async deleteAccessLog(id: number): Promise<void> {
      await api.delete(id);
    },
  };
}

export type AmenityAccessLogService = ReturnType<typeof createAmenityAccessLogService>;
